import { IAuthSignIn, IJwtSignIn, TSocialProfile } from '@ftd/types'

import { BASE_URL } from '@/api/constants'
import { secureFetch } from '@/api/secure-fetch'
import { log } from '@/lib/logger'

export const apiSignInLocal = async (email: string, password: string): Promise<IAuthSignIn<string>> => {
  try {
    const res = await fetch(`${BASE_URL}/auth/local/sign-in`, {
      method: 'POST',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    })
    if (!res.ok) throw new Error('Failed to sign in')
    return res.json()
  } catch (error) {
    log.error('Error during sign-in:', error)
    throw error
  }
}

export const apiSignOutLocal = async (): Promise<void> => {
  const res = await secureFetch(`${BASE_URL}/auth/local/sign-out`, {
    method: 'POST',
    cache: 'no-store',
  })
  if (!res.ok) throw new Error('Failed to sign out')
}

export const apiSignInSocial = async (
  provider: string,
  profile: TSocialProfile,
  accessToken: string,
): Promise<IJwtSignIn> => {
  const res = await fetch(`${BASE_URL}/auth/social/${provider}/sign-in`, {
    method: 'POST',
    cache: 'no-store',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ profile, accessToken }),
  })
  if (!res.ok) throw new Error('Failed to sign in')
  return res.json()
}
